import { TODO } from '@b2b/types/core';
import angular, { IScope, ITimeoutService } from 'angular';

PriceListsCreateModalDatePickerController.$inject = ['$scope', '$timeout', 'UserPreferencesService'];

function PriceListsCreateModalDatePickerController(
  $scope: IScope & { priceListsCreateModalDatePicker: TODO; dt: TODO; maxDate: TODO; minDate: TODO },
  $timeout: ITimeoutService,
  UserPreferencesService: TODO
) {
  $scope.priceListsCreateModalDatePicker = {
    isOpen: false,
    isPreferenceLoaded: false,

    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false,
    },

    init: function () {
      $scope.minDate = this.getMinDate();
      $scope.maxDate = this.getMaxDate();
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
        $scope.priceListsCreateModalDatePicker.isPreferenceLoaded = true;
      }, 0);
    },

    today: function () {
      this.dt = new Date();
    },

    clear: function () {
      $scope.dt = null;
    },

    getMinDate: function () {
      const d = new Date();

      d.setMonth(0);
      d.setDate(1);

      return d;
    },

    getMaxDate: function () {
      const d = new Date();

      d.setMonth(11);
      d.setDate(31);

      return d;
    },

    open: function ($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.minDate = this.getMinDate();
      $scope.maxDate = this.getMaxDate();

      this.isOpen = true;
    },

    onDateFormatLoad: function (e, data) {
      const self = $scope.priceListsCreateModalDatePicker;
      self.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      };
    },
  };

  $scope.priceListsCreateModalDatePicker.init();
}

export const PriceListsCreateModalDatePickerControllerModule = angular
  .module('acme.view.application.pricing.lists.createModalDatePicker.controllers', [
    'acme.common.service.userPreferences',
  ])
  .controller('PriceListsCreateModalDatePickerController', PriceListsCreateModalDatePickerController).name;
